export const blogBannerContent = (
    <div className='text-2xl'>
      Blog
    </div>
  )